import React from 'react';

const defaultProps = {
  name: null,
  label: null,
  type: "text",
  validator: null,
  register: null,
};

const Field = ({label, type, name, validator, register, ...custom}) => (
  <div className="field">
    <label className="label">{label}</label>
    <div className="control">
      <input
        name={name}
        type={type}
        className="input"
        ref={validator}
        {...register}
        {...custom} />
    </div>
  </div>
)

export default Field;

Field.defaultProps = defaultProps;